import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import JobDetailSection from "../components/JobDetail/JobDetailSection.js";
import Navigation from "../components/Navigation/Navigation";
import Spinner from "../components/Spinner/Spinner";

function JobDetail() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <Banner pageName="Job Detail" />
      <JobDetailSection />
      <Footer />
    </div>
  );
}

export default JobDetail;
